<template>
    <div id="batchUpdateShipment">
        <a-modal :title="$t('publicLang.UploadPhoto')+' - '+this.asnNo" v-model="visible" width="68%" :maskClosable="false">

            <div class="vue-uploader">
                <div class="file-list">
                    <section v-for="(file, index) of files" class="file-item draggable-item">
                        <img :src="file.src" alt="" ondragstart="return false;">
                        <a :href="file.src" target="_blank" class="file-name">{{file.name}}</a>
                        <span class="file-remove" @click="remove(index)">+</span>
                    </section>
                    <section v-if="status == 'ready'" class="file-item">
                        <div @click="add" class="add">
                            <span style="font-size: 50px;">+</span>
                        </div>
                    </section>
                </div>
                <input type="file" accept="image/*" @change="fileSelected" ref="file" multiple="multiple">
                <p style="margin-left: 10px;" v-html="i+1+'. '+item" v-for="(item,i) in errMsg" />
            </div>

            <!--底部按钮-->
            <template slot="footer">
                <a-button v-if="files.length > 0" @click="upload" size="big" type="primary" :disabled="isUploading">{{ $t('publicLang.Upload') }}</a-button>
                <a-button v-else @click="closeWindow" size="big" type="primary">{{ $t('publicLang.Close') }}</a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import axios from "axios";
    import store from "../../../store";
    import cookie from "../../../api/cookie";
    import sessionManager from "@/utils/session-manager";
    export default{
        data(){
            return{
                labelSpan: '24',
                visible: false,
                fileName: '',//文件名称
                errMsg:[],
                fontColor:'red',
                paramsData: {},
                isUploading: false,
                defaultImg: "",
                asnUid:"",
                asnNo:'',//ASN号码
                IfStatusBtn:false,
                repeatflag: 0,
                status: 'ready',
                files: [],
                uploading: false,
                percent: 0,
                uploadType:'',//上传类型
            }
        },
        methods:{
            show(param){
                this.isUploading = false
                this.visible = true
                this.paramsData = param
                this.fromData = {}
                this.files= []
                this.errMsg = []
                let params = {}
                this.asnUid = param.uidList;
                params.asnUid = param.uidList;
                this.uploadType =  param.uploadType;
                this.getAsnNoByUid(params);
            },
            getAsnNoByUid(params){//根据Uid查询ASN号码
                if(params.asnUid!=null){
                    this.asnNo= params.asnUid;
                }
                else{
                    ajax.get(api.SCANINIDGET,params).then(res=>{
                        this.asnNo = res.data.recId
                    });
                }
            },
            closeWindow(){
                this.visible = false;
            },
            add() {
                this.$refs.file.click()//调用file的click事件
            },
            upload() {
                let param = new FormData();
                let size = 0;//上传文件大小总和
                this.files.forEach(file => {
                    param.append("file", file.file);
                    size += file.size;
                });
                if(size > 500*1024*1024){//单位MB(上传的文件总大小不能超过500M)
                    this.$customMessage.warning(this.$t('asnPage.filesMaxSize'), 5);
                    return;
                }
                this.isUploading = true;
                param.append("asnNo", this.asnNo);
                param.append("uploadType", this.uploadType);
                this.post("/inbound/uploadFile", param).then(res => {
                    if (res.code == 200) {
                        let success = res.data.successMsg.split("!");
                        for (let i = 0; i < success.length - 1; i++) {
                            this.errMsg.push('<span style="color: green;">' + success[i] + '</span>')
                        }
                        let failed = res.data.failedMsg.split("!");
                        for (let i = 0; i < failed.length - 1; i++) {
                            this.errMsg.push('<span style="color: red;">' + failed[i] + '</span>')
                        }
                    }else{
                        let msgs = res.msg.split("!");
                        for (let i = 0; i < msgs.length - 1; i++) {
                            this.errMsg.push('<span style="color: red;">' + msgs[i] +'</span>');
                        }
                    }
                    this.files = [];
                    this.isUploading = false;
                });
            },
            post: function(url, data) {
                store.commit("updataLoading", { pbLoading: true });
                axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
                axios.defaults.timeout =  1000*60*60*12;//设置请求超时时间
                return new Promise((resolve, reject) => {
                    url = ajax.ajaxUrl() + url;
                    axios
                        .post(url, data)
                        .then(res => {
                            store.commit("updataLoading", { pbLoading: false });
                            let { data, status } = res;
                            if (status === 200) {
                                resolve(data);
                            } else {
                                reject(data);
                            }
                        })
                        .catch(err => {
                            store.commit("updataLoading", { pbLoading: false });
                            if (err.response.status == 401 || err.response.status == 403) {
                              const logoutURL = sessionStorage.getItem("logout") || "/login";
                              sessionManager.clearUserData();
                              window.location.hash = logoutURL;
                            }
                        });
                });
            },
            remove(index) {
                this.files.splice(index, 1)
            },
            fileSelected() {
                this.errMsg = [];//当重新选择图片时，需要清空错误提示
                const list = this.$refs.file.files
                for (let i = 0; i < list.length; i++) {
                    if (!this.isContain(list[i])) {
                        const item = {
                            name: list[i].name,
                            size: list[i].size,
                            file: list[i]
                        }
                        this.html5Reader(list[i], item)
                        this.files.push(item)
                    }
                }
                this.$refs.file.value = ''
            },
            // 将图片文件转成BASE64格式
            html5Reader(file, item){
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.$set(item, 'src', e.target.result)
                }
                reader.readAsDataURL(file)
            },
            isContain(file) {
                return this.files.find((item) => item.name === file.name && item.size === file.size)
            }
        }
    }
</script>
<style>
    .vue-uploader {
        border: 1px solid #e5e5e5;
    }
    .vue-uploader .file-list {
        padding: 10px 0px;
    }
    .vue-uploader .file-list:after {
        content: '';
        display: block;
        clear: both;
        visibility: hidden;
        line-height: 0;
        height: 0;
        font-size: 0;
    }
    .vue-uploader .file-list .file-item {
        float: left;
        position: relative;
        width: 100px;
        text-align: center;
    }
    .vue-uploader .file-list .file-item img{
        width: 80px;
        height: 80px;
        border: 1px solid #ececec;
    }
    .vue-uploader .file-list .file-item .file-remove {
        position: absolute;
        right: 12px;
        display: none;
        top: 4px;
        width: 14px;
        height: 14px;
        color: white;
        cursor: pointer;
        line-height: 12px;
        border-radius: 100%;
        transform: rotate(45deg);
        background: rgba(0, 0, 0, 0.5);
    }
    .vue-uploader .file-list .file-item:hover .file-remove {
        display: inline;
    }
    .vue-uploader .file-list .file-item .file-name {
        margin: 0;
        height: 40px;
        word-break: break-all;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .vue-uploader .add {
        width: 80px;
        height: 80px;
        margin-left: 10px;
        float: left;
        line-height: 80px;
        border: 2px dashed #ececec;
        cursor: pointer;
    }
    .vue-uploader .upload-func {
        display: flex;
        padding: 10px;
        margin: 0px;
        background: #f8f8f8;
        border-top: 1px solid #ececec;
    }
    .vue-uploader .upload-func .progress-bar {
        flex-grow: 1;
    }
    .vue-uploader .upload-func .progress-bar section {
        margin-top: 5px;
        background: #00b4aa;
        border-radius: 3px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        transition: all .5s ease;
    }
    .vue-uploader .upload-func .operation-box {
        flex-grow: 0;
        padding-left: 10px;
    }
    .vue-uploader .upload-func .operation-box button {
        padding: 4px 12px;
        color: #fff;
        background: #007ACC;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }
    .vue-uploader > input[type="file"] {
        display: none;
    }
</style>